// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__xkS-l","requiredAsterisk":"Info_requiredAsterisk__1IDvX"};